<template>
  <div>
    <div v-if="$store.state.step === 3" class="text-center">
      <h4>Edit Outro</h4>
      <div style="80%">
        <b-form-textarea
          id="outroCTA"
          name="outroCTA"
          placeholder="Outro Call To Action Blurb"
          v-model="outroCTA"
          rows="3"
        ></b-form-textarea>
        <b-form-textarea
          id="outroPhone"
          name="outroPhone"
          placeholder="Phone Number"
          v-model="outroPhone"
          rows="1"
        ></b-form-textarea>
        <b-form-textarea
          id="outroEmail"
          name="outroEmail"
          placeholder="Email Address"
          v-model="outroEmail"
          rows="1"
        ></b-form-textarea>
      </div>
      <br />
      <br />
    </div>
  </div>
</template>
<script>
export default {
  name: "StepThree",
  mounted() {},
  data: function() {
    return {
      no_headshot: "https://i.imgur.com/Gcvs580m.png",
    };
  },
  computed: {
    outroCTA: {
      get() {
        return this.$store.state.customization.outroCTA;
      },
      set(value) {
        this.$store.commit("changeOutroCTA", value);
      },
    },
    outroPhone: {
      get() {
        return this.$store.state.customization.outroPhone;
      },
      set(value) {
        this.$store.commit("changeOutroPhone", value);
      },
    },
    outroEmail: {
      get() {
        return this.$store.state.customization.outroEmail;
      },
      set(value) {
        this.$store.commit("changeOutroEmail", value);
      },
    },
  },
  methods: {
    next() {
      this.$store.commit("changeStep", 4);
    },
    prev() {
      this.$store.commit("changeStep", 2);
    },
    setStep(newStep) {
      this.$store.commit("changeStep", newStep);
    },
  },
};
</script>
